// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"622a17d6","235":"662752d2","669":"e58b0a69"}[chunkId] + ".chunk.js";
};